export const PASSWORD_REGEX_ONE_UPPERCASE = "(?=.*?[A-Z])";
export const PASSWORD_REGEX_ONE_LOWERCASE = "(?=.*?[a-z])";
export const PASSWORD_REGEX_ONE_NUMBER = "(?=.*?[0-9])";
export const PASSWORD_REGEX_ONE_SPECIAL_CHAR = "(?=.*?[#?!@$%^&*-])";
export const PASSWORD_REGEX_MINIMUM_EIGHT_LENGTH = ".{8,}";
export const EMAIL_REGEX = /^\S+@\S+\.\S+$/;
